import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ComponentType } from '@angular/cdk/overlay';

@Injectable()
export class EditDialogService {
  showError(arg0: string) {
      throw new Error('Method not implemented.');
  }

  constructor(public dialog: MatDialog) { }

  openModal<T>(cType: ComponentType<T>, configure: Function) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = true;
    dialogConfig.minWidth = 400;
    configure(dialogConfig);
    return this.dialog.open(cType, dialogConfig); // <-- return the dialog reference
  }

}
